module.exports = __webpack_public_path__ + "static/media/direction-rtl.bb28e8bf.svg";